export enum AnesthesiaType {
  NONE = 'NONE',
  SLEEP = 'SLEEP', //수면마취
  GENERAL = 'GENERAL', //전신마취
  LOCAL_INJECTION = 'LOCAL_INJECTION', //국소마취 - 주사
  LOCAL_CREAM = 'LOCAL_CREAM', //국소마취 - 크림
  LOCAL_ICE = 'LOCAL_ICE', //국소마취 - 얼음
  OTHERS = 'OTHERS', //기타
}
